export enum SupportedFileType {
  docx = "docx",
  pptx = "pptx",
  xlsx = "xlsx",
  pdf = "pdf",
  jpg = "jpg",
  mp4 = "mp4",
  webm = "webm"
}
